import Vue from 'vue'

const env = {
  apiUrl: process.env.VUE_APP_API_URL,
  mapBoxToken: process.env.VUE_APP_MAPBOX_TOKEN,
  sentryDsn: process.env.VUE_APP_SENTRY_DSN
}

Vue.prototype.$env = env

export default env
